import React from "react";
import { Button } from "../ui/Button";
import { VideoPlayer } from "../ui/VideoPlayer";
import { SectionBackgroundIcons } from "../ui/BackgroundIcons";
import type { HeroSection as HeroSectionType } from "../../types/content.types";

interface HeroSectionProps {
  content: HeroSectionType;
  onCtaClick: () => void;
}

export function HeroSection({ content, onCtaClick }: HeroSectionProps) {
  return (
    <section className="relative bg-black min-h-screen flex flex-col justify-center pt-28">
      <SectionBackgroundIcons variant="hero" />
      <div className="relative z-10 max-w-5xl mx-auto px-6 w-full text-center">
        <div className="flex flex-col items-center text-center gap-8">
          {/* Main Heading */}
          <h1 className="leading-tight max-w-4xl text-4xl sm:text-7xl lg:text-8xl">
            <span className="font-bold text-white block">Overlanding</span>
            <span className="block">
              <span className="font-bold text-white">Gear </span>
              <span className="font-normal text-[#a79c68]">For</span>
            </span>
            <span className="font-normal text-[#a79c68] block">4×4 Vehicles</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl sm:text-2xl leading-tight">
            <span className="block font-normal text-gray-300">Tried and tested for</span>
            <span className="block font-bold text-white">African Conditions</span>
          </p>

          {/* Video */}
          <div className="w-full">
            <VideoPlayer
              key={content.video}
              videoUrl={content.video}
              posterUrl={content.videoPoster}
              title={content.heading}
              autoplay={true}
            />
          </div>

          {/* CTA Button */}
          <div className="flex justify-center mt-6">
            <Button variant="primary" size="lg" onClick={onCtaClick}>
              {content.ctaText}
            </Button>
          </div>

          {/* Scroll Chevron */}
          <div className="flex flex-col items-center gap-1 mt-8 opacity-80">
            <span className="text-[#a79c68] text-xs tracking-[0.25em] uppercase">Scroll</span>
            <svg
              className="w-6 h-6 text-[#a79c68] animate-bounce"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}
